import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { AppSettingsClient } from '../../../shared/AppSettingsClient';
import {
    UserDeleteCommand,
    UserExportCSVQuery,
    UserExportPDFQuery,
    UserExportQuery,
    UserGetListQuery,
    UserListResponse,
    UserServiceProxy
} from '../../../shared/service-proxies/service-proxies';
import { FileService } from '../../../shared/services/file.service';
import { SettingsClientService } from '../../../shared/services/settingsclient.service';
import { AppComponentBase, PagedTableSummary } from '../../app-component-base';
import { AppComponent } from '../../app.component';
import { AuthenticationService } from '../../_services/authentication.service';
import { HttpClient } from '@aspnet/signalr';
import { AppConsts } from '../../../shared/AppConsts';
import { AppAbout } from '../../../shared/AppAbout';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    templateUrl: './acercade.component.html'
})
export class AcercaDeComponent extends AppComponentBase implements OnInit {

    form: FormGroup;
    aboutApp: AppAbout;

    constructor(
        injector: Injector,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
    ) {
        super(injector);

    }

    ngOnInit() {
        const self = this;

        self.aboutApp = AppConsts.aboutApp;
    }

    close(): void {
        const self = this;
        self.modalRef.close();
    }
}
